module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Agent Password Form")]), _vm._v(" "), _c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Agent Name\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "formatter": _vm.capitalizeAll,
      "id": "agentName",
      "name": "agentName",
      "placeholder": "Please Enter Client Name",
      "type": "text"
    },
    model: {
      value: (_vm.agentUserForm.agentName),
      callback: function($$v) {
        _vm.$set(_vm.agentUserForm, "agentName", $$v)
      },
      expression: "agentUserForm.agentName"
    }
  }), _vm._v(" "), (!_vm.agentUserForm.agentName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.agentName) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("\n                  Common Email\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "formatter": _vm.capitalizeAll,
      "id": "emailId",
      "name": "emailId",
      "placeholder": "Please Enter Email ID",
      "type": "text"
    },
    model: {
      value: (_vm.agentUserForm.emailId),
      callback: function($$v) {
        _vm.$set(_vm.agentUserForm, "emailId", $$v)
      },
      expression: "agentUserForm.emailId"
    }
  }), _vm._v(" "), (!_vm.agentUserForm.emailId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.emailId) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('label', [_vm._v("\n                      Common Password\n                      "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.agentUserForm.agntColoaderId ? false : true,
      "formatter": _vm.capitalizeAll,
      "id": "password",
      "name": "password",
      "placeholder": "Please Enter Password",
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.PasswordChangeFlag()
      }
    },
    model: {
      value: (_vm.agentUserForm.agent_pass),
      callback: function($$v) {
        _vm.$set(_vm.agentUserForm, "agent_pass", $$v)
      },
      expression: "agentUserForm.agent_pass"
    }
  }), _vm._v(" "), (!_vm.agentUserForm.agent_pass) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                      " + _vm._s(_vm.errorList.agent_pass) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-5",
    attrs: {
      "sm": "4"
    }
  }, [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    on: {
      "click": _vm.generatePassword
    }
  }, [_vm._v("Generate")])], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    staticClass: "text-left",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": 'info'
    },
    on: {
      "click": function($event) {
        _vm.ActiveAccordion(_vm.UserActiveStatus)
      }
    }
  }, [_vm._v("Show Users")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(
    _vm.agentUserForm.agent_user_list.length > 0 || _vm.UserActiveStatus
  ) ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("User Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                        Actions\n                        "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addAgentUser()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.agentUserForm.agent_user_list), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "text",
        "placeholder": "Enter User Name"
      },
      model: {
        value: (item.user_name),
        callback: function($$v) {
          _vm.$set(item, "user_name", $$v)
        },
        expression: "item.user_name"
      }
    }), _vm._v(" "), (item.user_name_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.user_name_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "text",
        "placeholder": "Enter User EMail"
      },
      model: {
        value: (item.user_email),
        callback: function($$v) {
          _vm.$set(item, "user_email", $$v)
        },
        expression: "item.user_email"
      }
    }), _vm._v(" "), (item.user_email_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.user_email_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "text",
        "placeholder": "Enter User Password"
      },
      model: {
        value: (item.user_pass),
        callback: function($$v) {
          _vm.$set(item, "user_pass", $$v)
        },
        expression: "item.user_pass"
      }
    }), _vm._v(" "), (item.user_pass_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.user_pass_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(index > 0) ? _c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeAgentUser(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1)])
  })], 2)])])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin": "left:5px",
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.isLoading ? true : false,
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.addAgentUserForm
    }
  }, [_vm._v("Save")]), _vm._v(" "), (
    (_vm.agentUserForm.fk_agent_id &&
      _vm.agentUserForm.is_approval_mail_send == 0) ||
    _vm.agentUserForm.is_approval_mail_send == 2
  ) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.sendAgentMail(_vm.agentUserForm)
      }
    }
  }, [_vm._v("Send Mail")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68357086","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/agentColoader/upsertAgentUser.vue
// module id = 2703
// module chunks = 0